import React, { useEffect } from 'react';

import { handleAuthEvent } from '../utils/LoaderEmitter';

import Dropdown from 'react-bootstrap/Dropdown';
import { Image } from '@fluentui/react-northstar';
import { imageAssets, iconAssets } from '../assets/theme/theme';

import '../styles/Header.css';


const Header = ({ mSALObj, loggedInUserName }) => {

    let userName = '';
    if (!loggedInUserName) {
        let userDetail = JSON.parse(localStorage.getItem('userDetail')) || {};
        userName = userDetail['firstName'] + ' ' + userDetail['lastName'];
    }

    const logoutProcess = () => {
        localStorage.clear();
        sessionStorage.clear();
        mSALObj.logout();
    }

    useEffect(() => {
        const authHandler = async (detail) => {
            mSALObj.logout();
        }

        handleAuthEvent.on('login', authHandler);
    }, []);

    return (
        <>
            <div className='row p-0 m-0 w-100'>
                <div className='col p-0'>
                    <Image src={imageAssets.ariyaLogo} className="ariya-logo" />
                </div>
                <div className='col p-0 d-flex align-items-center'>
                    <div className='row p-0 m-0 w-100 d-flex justify-content-end'>
                        <div className='col-auto'>
                            <div className='user-profile d-flex justify-content-center align-items-center'>
                                <Image src={iconAssets.user} alt="" className="user-icon" />
                            </div>
                        </div>
                        <div className='col-auto pe-1 user-name'>
                            {loggedInUserName || userName}
                        </div>
                        <div className='col-auto p-0 logout'>
                            <Dropdown>
                                <Dropdown.Toggle>
                                    <Image src={iconAssets.downArrow} alt="" className="down-arrow" />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <div className='row p-0 m-0 cursor-pointer' onClick={() => logoutProcess()}>
                                        <div className='col-auto p-0 d-flex align-items-center'>
                                            <Image src={iconAssets.logout} alt="" className="logout-icon" />
                                        </div>
                                        <div className='col px-2 d-flex align-items-bottom'>
                                            <div className=''>Log out</div>
                                        </div>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Header